import type { FaireProductEntity } from "../../entity_types/product";

export const p_46ynjt9tmy: FaireProductEntity = {
  token: "p_46ynjt9tmy",
  type: "product",
  name: "Gold Rope Chain Necklace",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/d61b1acda21ebeb4bf042aa4aa9179cbae0036f49db4e90945f0f1e269d0cb69.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/26e4f391c9ca3023e9693291678bc7aa60770b2a1e7efb4c78f96ae10b8f4678.jpeg",
    "https://cdn.faire.com/fastly/5cd8104a35875c5de3f29080f96c1a5593459bbf3f83ac19e55768979c908b8a.jpeg",
    "https://cdn.faire.com/fastly/6d63cb6c457cb47a499b04cacdceddfb3b43dcd5ffe26c16d3de3fe93d9880da.jpeg",
    "https://cdn.faire.com/fastly/464d2b3412d28558f7cf0d9d8d022c43ac38bf0515423eb3ab2d7d3a62909d43.jpeg",
    "https://cdn.faire.com/fastly/014c95068a4faa86310c2397591d0d6151529c3efd9090fa4a59359f1f843f8c.jpeg",
    "https://cdn.faire.com/fastly/1b74848a2b51786566d2686c529dda0c07c80127bd1e74da350f4cb01d6e31e2.jpeg",
    "https://cdn.faire.com/fastly/f51fad108c682bbffe8cd83df33d93ba61988bc6b3b6feb8a39361b31713ce8d.jpeg",
    "https://cdn.faire.com/fastly/d345be7b3aebbdd905b396e85e9c01df9fc59770b5693eee75004c2060667b66.jpeg",
    "https://cdn.faire.com/fastly/7f37ff1c8aee8bb6bf6915ec5c6bd657b6a69941c66290d7915d5606f43dc0dc.jpeg",
    "https://cdn.faire.com/fastly/f8e232955d4414f40ed5a41891190bcdf594c61009a790ada19e93c359bf1e80.jpeg",
    "https://cdn.faire.com/fastly/fabca5a6c496b24a58d739e74b2dc99ccf3ee0735f25617dd6e887fa2adfbdf8.jpeg",
    "https://cdn.faire.com/fastly/192ae13d2d51daf1defe0530baedccc86dcfbd383c78d9b928cb7d6bf6704d5f.jpeg",
    "https://cdn.faire.com/fastly/b8054b70ab027a472afa36b41f8a54fa71dcf0da4da47d5f28bf11ac48301a23.jpeg",
    "https://cdn.faire.com/fastly/b45650842e4012ff3bfd9c3b4713f1e664012a09cf4d1373f0ca022de797ac97.jpeg",
    "https://cdn.faire.com/fastly/06e4d4d4795cec7f1550b17e0d02702e93ccb84d289a7bba76e06e2f4ede9a26.jpeg",
    "https://cdn.faire.com/fastly/09a2a8b7ac7bc3a805b24bd1ce3b947b412663eab24fade7f7af7d171ec1c2fe.jpeg",
  ],
  priceDollars: 3,
  description:
    "This Rope Chain Necklace has a timeless elegance to it that will make it the perfect holiday gift! This necklace features a beautifully twisted design that adds a touch of sophistication to any outfit. It's a simple, casual necklace that can be worn anywhere and with anything, but the best part? You can add your favorite small pendants to add your own touch or even layer it with other gold chains to create a layered necklace look. \n\n• Waterproof, non-tarnish, hypoallergenic \n• 18K Gold PVD coated 316L Stainless Steel \n• Lightweight and designed for everyday wear\n• Great for layering with other necklaces\n\nWe use the process of PVD Coating our 18K Gold jewelry over 316L stainless steel for a non-tarnish, hypoallergenic, polished finish that will hold up best to everyday wear and will never turn your customer's skin green.\n\nApprox. Weight: 6 grams",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:44.833Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
